export default function PHP_date_sun_info() {
  return (
    <div>
      <h1>PHP_date_sun_info</h1>
    </div>
  );
}
